import {
	Table,
	TableBody,
	TableCell,
	TableHead,
	TableRow,
	Typography,
} from "@mui/material";
import { FeatureDto } from "Infrastructure/Models/Messages/Dto/FeatureDto";
import CancelIcon from "@mui/icons-material/Cancel";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";

export const CategoryFeatureTable = ({
	features,
}: {
	features: FeatureDto[];
}) => {
	if (features.length === 0) {
		return (
			<Typography
				variant="body2"
				color="text.secondary"
				ml={1}
				sx={{
					fontSize: "0.7rem",
				}}
			>
				Žádné
			</Typography>
		);
	}

	return (
		<Table
			size="small"
			sx={{
				minWidth: "900px",
				width: "100%",
				tableLayout: "fixed",
			}}
		>
			<TableHead>
				<TableRow>
					<TableCell
						sx={{
							width: "40%",
							fontSize: "0.75rem",
							fontWeight: "bold",
						}}
					>
						FeatureCode
					</TableCell>
					<TableCell
						sx={{
							width: "15%",
							fontSize: "0.75rem",
							fontWeight: "bold",
						}}
					>
						IsEnabled
					</TableCell>
					<TableCell
						sx={{
							width: "15%",
							fontSize: "0.75rem",
							fontWeight: "bold",
						}}
					>
						IsSelfInsEnabled
					</TableCell>
					<TableCell
						sx={{
							width: "10%",
							fontSize: "0.75rem",
							fontWeight: "bold",
						}}
					>
						Pro účty
					</TableCell>
					<TableCell
						sx={{
							width: "20%",
							fontSize: "0.75rem",
							fontWeight: "bold",
						}}
					>
						Aktualizováno
					</TableCell>
				</TableRow>
			</TableHead>
			<TableBody>
				{features.map((feature) => (
					<TableRow key={feature.code}>
						<TableCell
							sx={{
								fontSize: "0.7rem",
								wordBreak: "break-word",
								overflow: "hidden",
								textOverflow: "ellipsis",
							}}
						>
							{feature.code || "?"}
						</TableCell>
						<TableCell sx={{ fontSize: "0.7rem" }}>
							{feature.isEnabled ? (
								<CheckCircleIcon
									sx={{ fontSize: "0.7rem", color: "success.main" }}
								/>
							) : (
								<CancelIcon sx={{ fontSize: "0.7rem", color: "error.main" }} />
							)}
						</TableCell>
						<TableCell sx={{ fontSize: "0.7rem" }}>
							{feature.isSelfInsEnabled ? (
								<CheckCircleIcon
									sx={{ fontSize: "0.7rem", color: "success.main" }}
								/>
							) : (
								<CancelIcon sx={{ fontSize: "0.7rem", color: "error.main" }} />
							)}
						</TableCell>
						<TableCell sx={{ fontSize: "0.7rem" }}>
							{feature.isForAccounts === null ? (
								"?"
							) : feature.isForAccounts ? (
								<CheckCircleIcon
									sx={{ fontSize: "0.7rem", color: "success.main" }}
								/>
							) : (
								<CancelIcon sx={{ fontSize: "0.7rem", color: "error.main" }} />
							)}
						</TableCell>
						<TableCell sx={{ fontSize: "0.7rem" }}>
							{feature.dateUpdated
								? new Date(feature.dateUpdated).toLocaleDateString()
								: "?"}
						</TableCell>
					</TableRow>
				))}
			</TableBody>
		</Table>
	);
};
